<template>
  <div>
    <div
      class="signature-content"
      @click="openModal"
    >
      <div class="signature-image">
        <img
          v-show="imgUrl"
          :id="imgId"
          :src="imgUrl"
        >
      </div>
      <span class="signature-link">{{ message }}</span>
    </div>
    <Modal
      ref="signaturePadModal"
      class="signature-modal"
      :modalId="modalId"
      :showBtns="true"
      modalType="medium-modal"
    >
      <div slot="modal-header">
        <p class="font-bold">
          {{ $t('hint.pleaseSignBelow') }}
        </p><p /><p> {{ hintBeforeSignature }}</p>
      </div>
      <div
        slot="content"
        class="signature-pad"
      >
        <canvas
          :id="padId"
          width="600"
          height="200"
        />
      </div>
      <div slot="btns">
        <button
          class="btn--orange"
          :disabled="signaturePad? signaturePad.isEmpty() : true"
          @click="saveSignature"
        >{{ $t('action.confirm') }}</button>
        <button
          class="btn--darkblue"
          @click="clearSignature"
        >{{ $t('action.clear') }}</button>
      </div>
    </Modal>
  </div>
</template>

<script>
import SignaturePad from 'signature_pad'
import Modal from '@/controls/Modal'
import i18n from '@/utils/i18n'

export default {
  components: {
    Modal,
  },
  props: {
    hintBeforeSignature: {
      type: String,
      default: i18n.t('hint.signatureNotSave'),
    },
    message: {
      type: String,
      default: i18n.t('signature'),
    },
    isEditable: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    const modalId = `signature-feild-${new Date().getTime()}-${Math.floor(Math.random() * 1000)}`
    const imgId = `image-${new Date().getTime()}-${Math.floor(Math.random() * 1000)}`
    const padId = `pad-${new Date().getTime()}-${Math.floor(Math.random() * 1000)}`
    return {
      modalId,
      imgUrl: '',
      imgId,
      padId,
      signaturePad: null,
    }
  },
  mounted () {
    this.cavans = document.getElementById(this.padId)
    this.signaturePad = new SignaturePad(this.cavans, {
      backgroundColor: 'rgb(255, 255, 255)',
      minWidth: 2,
      maxWidth: 5,
    })
  },
  methods: {
    openModal () {
      if (this.isEditable) {
        this.$refs.signaturePadModal.open()
      }
    },
    closeModal () {
      this.$refs.signaturePadModal.close()
    },
    saveSignature () {
      if (this.signaturePad.isEmpty()) {
        return
      }
      this.imgUrl = this.signaturePad.toDataURL('image/png')
      this.closeModal()
    },
    clearSignature () {
      if (this.signaturePad) {
        this.signaturePad.clear()
        this.imgUrl = ''
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import '~styles/common';

.signature-pad {
  display: flex;
  justify-content: center;
  canvas {
    box-shadow: 4px 4px 4px 4px rgba(212, 212, 212, 0.5);
  }
}
.signature-image {
  margin: auto;
  padding-bottom: 1px;
  width: 200px;
  height: 40px;
  text-align: center;
  img {
    max-height: 100%;
  }
}
.signature-link {
  border-top: 1px solid black;
  display: block;
  font-size: 12px;
  font-style: italic;
  text-align: center;
}
</style>
